$shm_hitalama_map_widget_float_table_form $mol_view
	table $shm_hitalama_map_widget_float_table
	row_index -1
	title \Форма
	sub /
		<= Form_head $mol_view
			sub /
				<= Form_title $mol_view
					sub / <= Form_title_text $mol_view
						sub / <= title
				<= Close $mol_button_minor
					title \Закрыть
					click? <=> close? null
		<= Form $mol_form
			form_fields <= form_fields /
				<= Field*0 $mol_form_field
					name <= field_name* \
					bid <= field_bid* \
					Content <= Field_content* $mol_view
			submit_allowed => submit_allowed
			buttons <= buttons /
				<= Actions $mol_view
					sub /
						<= Publish $shm_hitalama_form_submit
							title \Отправить
							click? <=> submit? null
							enabled <= submit_allowed
						<= Clear_actions $mol_view
							sub /
								^ clear_button_visible /
									<= Clear $mol_button_minor
										title \Очистить
										click? <=> clear_ask? null
								^ clear_confirm_visible /
									<= Clear_confirm $mol_button_major
										title \Подтвердить очистку
										click? <=> clear_confirm? null
									<= Clear_cancel $mol_button_minor
										title \Отмена
										click? <=> clear_cancel? null
				^ submit_result_visible /
					<= Submit_result $mol_status
						message <= submit_result? \
						style *
							^
							color \var(--shm_theme_success)
	clear_asked? false
	submit_result? \
	Content_by_type* *
		any
			<= String*
		string
			<= String* $mol_string
				value? <=> field_value*? null
		textarea
			<= Textarea* $mol_textarea
				value? <=> field_value*?
		date
			<= Date* $shm_date_view
				value? <=> field_value*?
		number
			<= Number* $mol_number
				value? <=> field_number*? NaN
		period
			<= Period* $shm_period
				period? <=> field_value*?
				period_str => period_str*
		file
			<= File* $shm_hitalama_file_attach
				files? <=> field_files*? /
				value? <=> field_value*?
		file_pb
			<= File_pb* $shm_hitalama_file_attach_pb
				value? <=> field_value*?
				map_id <= pb_map_id \
				widget_id <= pb_widget_id \
				field_name <= field_name* \
		atom_link
			<= Atom_link* $shm_hitalama_map_widget_float_table_relation_atom
				value? <=> field_value*? null
				dictionary <= field_link_options* *
				active <= field_relation_active* \
				open? <=> field_relation_open*? \
				create? <=> field_relation_create*? null
		list_link
			<= List_link* $shm_hitalama_map_widget_float_table_relation_list
				value? <=> field_list_value*? /string
				dictionary <= field_link_options* *
				active <= field_relation_active* \
				open? <=> field_relation_open*? \
				create? <=> field_relation_create*? null
				create_current <= field_relation_create_current* false
		select
			<= Select* $mol_select
				value? <=> field_value*? null
				dictionary <= field_select_dictionary* *
				Filter null

$shm_hitalama_map_widget_float_table_col_name $mol_string
	commit? null
	submit? <=> commit?
	event *
		^
		blur? <=> commit?

$shm_hitalama_map_widget_float_table_relation_form $shm_hitalama_map_widget_float_table_form
	table_relation null
	page_index 0

$shm_hitalama_map_widget_float_table_link_list $shm_check_list
	table_relation null
	cell_id null

$shm_hitalama_map_widget_float_table $shm_hitalama_map_widget_float
	table_scroll_top? 0
	table_viewport_height 0
	table_header_height 40
	table_virtual false
	attr *
		^
		shm_hitalama_map_widget_float_table_fullscreen <= fullscreen false
		relation_open <= relation_stack_open false
	head / <= Widget_title_edit $mol_string_button
		value? <=> title?
	Table_content $shm_hitalama_map_table
		controller <= table_self
	controls /
		<= Workspace $mol_view
			style *
				height \100%
			sub <= workspace_content /
				<= Create_panel $mol_view
					sub /
						<= Create_form $shm_hitalama_map_widget_float_table_form
							table <= table_self
							row_index -1
							title <= edit_form_title \
				<= Table_panel $mol_view
					sub /
						<= Table_scroll $mol_scroll
							sub /
								<= Table $shm_hitalama_map_widget_float_table_grid
									records <= rows *
									scroll_top? <=> table_scroll_top?
									viewport_height <= table_viewport_height
									col_ids <= col_ids /
									col_head_content* <= col_head_content* /
									Col_head* <= Col_head* $mol_float
										dom_name \th
										sub <= col_head_content* /
										style *
											^
											padding <= col_head_padding* \var(--mol_gap_text)
											width <= col_head_width* \auto
											maxWidth \600px
									cell_content_text* => cell_content_text*
									Cell* <= Cell* $mol_view
									row_ids <= table_row_ids /string[]
									header_height <= table_header_height
									render_visible_only <= table_virtual
									Row* <= Grid_row* $mol_grid_row
										cells <= grid_cells* /$mol_view
										attr *
											^
											selected <= row_selected* false
								^ empty_content /
									<= Empty $mol_view
										sub / <= empty_message \
						<= Table_toolbar $mol_view
							sub /
								<= Query_tools $mol_view
									sub /
										^ search_field_visible /
											<= Search $mol_search
												hint \Поиск по таблице
												query? <=> search? \
										^ query_status_visible /
											<= Query_status $mol_view
												sub / <= query_status \
										^ reset_visible /
											<= Reset_filters $mol_button_minor
												title \Сбросить фильтры
												click? <=> reset_filters? null
								^ active_filter_content /
									<= Active_filters $mol_view
										sub / <= active_filter_text \
								^ add_tools_visible /
									<= Add_row $mol_button_minor
										title \Добавить строку
										hint \Добавить строку
										click? <=> add? null
										sub /
											<= Add_row_icon $mol_icon_plus
											\Добавить строку
										attr *
											^
											active <= add_active false
											aria-pressed <= add_active false
									<= Add_column $shm_hitalama_map_widget_float_table_command
										title \Добавить столбец
										hint \Добавить столбец в конец таблицы
										click? <=> add_column? null
										sub /
											<= Add_column_icon $mol_icon_plus
											\Добавить столбец
									<= Edit_table $mol_button_minor
										title \Редактировать таблицу
										hint \Переключить таблицу и её настройки
										click? <=> table_edit_toggle? null
										sub /
											<= Edit_table_icon $mol_icon_table_edit
											\Редактировать таблицу
										attr *
											^
											active <= table_edit_active false
											aria-pressed <= table_edit_active false
									<= Search_toggle $mol_button_minor
										title \Поиск
										hint \Показать или скрыть поиск по таблице
										click? <=> search_toggle? null
										sub /
											<= Search_toggle_icon $mol_icon_magnify
											\Поиск
										attr *
											^
											active <= search_active false
											aria-pressed <= search_opened false
								^ pagination_visible /
									<= Pagination_controls $mol_view
										sub /
											<= Pagination $mol_paginator
												value? <=> page_index? 0
												Value <= Pagination_value $mol_view
													sub / <= page_label \
												backward_hint \Предыдущая страница
												forward_hint \Следующая страница
											<= Page_size_label $mol_labeler
												title \Показывать по:
												Content <= Page_size $mol_select
													Filter null
													value? <=> page_size_selected? \
													options /
														\25
														\50
														\100
													dictionary *
														0 \Все
				<= Table_editor_panel $mol_view
					sub /
						<= Table_editor_head $mol_view
							sub /
								<= Table_editor_title $mol_view
									sub / \Настройки таблицы
								<= Table_editor_close $mol_button_minor
									title \Закрыть
									click? <=> table_edit_close? null
						<= Table_editor $mol_scroll
							sub /
								<= Table_editor_content $mol_list
									rows <= table_editor_fields /
										<= Table_schema_field $mol_form_field
											name \Поля формы
											Content <= Table_schema $mol_textarea
												value? <=> table_schema? \
												hint \Название* #string — одно поле на строку
												spellcheck false
												enabled <= table_schema_enabled true
										<= Table_rows_limit_field $mol_form_field
											name \Лимит строк
											Content <= Table_rows_limit $mol_number
												value? <=> table_rows_limit? 1000
												hint \0 — без лимита
												precision 1
												precision_change 1
										<= Table_delete_rows $mol_check_box
											title \Удаление строк
											checked? <=> delete_enabled? false
										<= Table_widths_field $mol_form_field
											name \Ширина столбцов
											Content <= Table_widths $mol_list
												rows <= col_width_rows
										<= Table_visibility_field $mol_form_field
											name \Видимость столбцов
											Content <= Table_visibility $shm_check_list
												options <= column_visibility_options /string
												value? <=> columns_visible? /string
				<= Edit_panel $mol_view
					sub /
						<= Edit_form $shm_hitalama_map_widget_float_table_form
							table <= table_self
							row_index <= edit_row_index -1
							title <= edit_form_title \
	Table_relation_edit_panel* $mol_view
		sub / <= Table_relation_edit_form* $shm_hitalama_map_widget_float_table_relation_form
			table <= table_self
			table_relation <= table_self
			page_index <= table_relation_page_index* 0
	table_relation_page_index* 0
	Column_editor $shm_hitalama_map_widget_float_table_column
		table <= table_self
		column <= column_editor_col
		close? <=> column_editor_close? null
		expanded? <=> column_editor_fullscreen? false
	column_editor_col? -1
	table_list_cell_id* null
	col_settings_title* \
	table_self null
	Cell_text* $mol_grid_cell
		sub /
			<= Cell_text_scroll* $mol_view
				sub / ^ cell_content_text*
			<= Copy_area* $mol_view
				sub /
					<= Cell_copy* $shm_button_copy
						button_sub / <= Copy_icon* $mol_icon_content_copy
						text <= cell_content_text_str* \
		style <= cell_style* *
			transition \none
			maxWidth <= col_width_px* \auto
			width <= col_width_px* \auto
	Cell_table_atom_link* $mol_grid_cell
		sub / <= Table_atom_link_content* $mol_view
			sub /
				^ table_atom_item_visible* /
					<= Table_atom_item* $mol_button_minor
						title <= table_atom_label* \
						click? <=> table_atom_open*? null
						attr *
							^
							selected <= table_atom_current* false
				<= Table_atom_pick* $mol_select
					value? <=> table_atom_value*? \
					dictionary <= table_relation_options* *
					trigger_content / <= Table_atom_pick_icon* $mol_icon_dots_vertical
				<= Table_atom_create* $mol_button_minor
					title \Создать связанную запись
					click? <=> table_relation_create*? null
					sub / <= Table_atom_create_icon* $mol_icon_plus
		style <= cell_style*
	Cell_table_list_link* $mol_grid_cell
		sub / <= Table_list_link_content* $mol_view
			sub /
				<= Table_list_pick* $mol_pick
					trigger_content / <= Table_list_pick_icon* $mol_icon_dots_vertical
					bubble_content / <= Table_list_options* $shm_hitalama_map_widget_float_table_link_list
						table_relation <= table_self
						cell_id <= table_list_cell_id*
						options <= table_list_option_ids* /string
						value? <=> table_list_picker_value*? /string
				<= Table_list_create* $mol_button_minor
					title \Создать связанную запись
					click? <=> table_relation_create*? null
					sub / <= Table_list_create_icon* $mol_icon_plus
					attr *
						^
						selected <= table_relation_create_current* false
				^ table_list_items* /$mol_view
		style <= cell_style*
	Cell_table_select* $mol_grid_cell
		sub / <= Table_select* $mol_select
			value? <=> table_select_value*? \
			dictionary <= table_select_options* *
			Filter null
		style <= cell_style*
	Table_list_item* $mol_button_minor
		title <= table_list_item_label* \
		click? <=> table_list_item_open*? null
		attr *
			^
			selected <= table_list_item_current* false
	Cell_file* $mol_grid_cell
		sub / <= Cell_file_scroll* $mol_view
			sub /
				^ cell_file_visible* /
					<= Download* $mol_button_download
						uri <= cell_file_uri* \
						file_name <= cell_file_name* \
						sub /
							<= Download_icon* $mol_icon_download
							<= cell_file_name*
					- <= Download* $mol_link
						uri <= cell_file_uri* \
						file_name <= cell_file_name* \
						sub /
							<= Download_icon* $mol_icon_download
							<= cell_file_name*
		style <= cell_style*
	Cell_file_pb* $mol_grid_cell
		sub / <= Cell_file_pb_scroll* $mol_view
			sub /
				^ cell_file_pb_visible* /
					<= Download_pb* $mol_link
						uri <= cell_file_pb_uri* \
						target \_blank
						sub /
							<= Download_pb_icon* $mol_icon_download
							<= cell_file_pb_name* \
		style <= cell_style*
	Cell_index_number* $mol_grid_cell
		sub / <= cell_index_number* \
	Cell_checkbox* $mol_grid_cell
		sub /
			<= Checkbox* $mol_check_box
				checked? <=> cell_checked*? false
	Cell_delete* $mol_grid_cell
		sub /
			^ cell_delete_visible* /
				<= Action_delete* $mol_button_minor
					title \Удалить
					click? <=> cell_delete*? null
	Cell_edit* $mol_grid_cell
		sub /
			<= Action_edit* $mol_button_minor
				title \Редактировать
				click? <=> cell_edit*? null
				attr *
					^
					active <= action_edit_active* false
					aria-pressed <= action_edit_active* false
	Cell_custom* $mol_grid_cell
		sub / <= Cell_custom_scroll* $mol_view
			sub <= custom_cell_content* /
		style <= cell_style*
	Add $mol_button_minor
		title \+
		hint \Добавить строку
		click? <=> add? null
		sub /
			<= Add_icon $mol_icon_plus
		attr *
			^
			active <= add_active false
			aria-pressed <= add_active false
			aria-label \Добавить строку
	Col_resize* $shm_hitalama_map_widget_float_table_resize
		width? <=> col_width*?
		style *
			^
			right <= col_resize_right* \-2px
	Col_head_content* $mol_view
		sub /
			<= Col_head_title* $mol_view
				sub / <= col_settings_title*
			<= Col_indicators* $mol_view
				sub / <= col_indicators* \
				attr *
					^
					title <= col_indicators_hint* \
			<= Col_settings* $shm_hitalama_map_widget_float_table_pick
				trigger_content /
					<= Col_settings_icon* $mol_icon_dots_vertical
				bubble_content /
					<= Col_settings_bubble* $mol_view
						sub /
							<= Filter_label* $mol_labeler
								title \Фильтр
								Content <= Column_filter* $shm_hitalama_map_widget_float_table_filter
							<= Sort_label* $mol_labeler
								title \Сортировка
								Content <= Sort* $shm_hitalama_map_widget_float_table_select
									Filter null
									value? <=> column_sort*? \none
									dictionary *
										none \Без сортировки
										asc \По возрастанию
										desc \По убыванию
							<= Pin* $mol_check_box
								title \Закрепить слева
								checked? <=> column_pinned*? false
							<= Move_left* $mol_button_minor
								title \Переместить левее
								click? <=> column_left*? null
							<= Move_right* $mol_button_minor
								title \Переместить правее
								click? <=> column_right*? null
							<= Col_name_label* $mol_labeler
								title \Название
								Content <= Col_name* $shm_hitalama_map_widget_float_table_col_name
									value? <=> col_name_draft*? \
									commit? <=> col_name_commit*? null
							<= Col_width_label* $mol_labeler
								title \Ширина, px
								Content <= Col_settings_width* $mol_number
									Dec null
									Inc null
									value? <=> col_width*? NaN
									hint \auto
							<= Col_type_label* $mol_labeler
								title \Тип
								Content <= Col_type* $shm_hitalama_map_widget_float_table_select
									value? <=> col_type*? \any
									dictionary <= col_type_options *
									Filter null
							^ relation_dataset_visible* /
								<= Relation_dataset_label* $mol_labeler
									title \Связанная таблица
									Content <= Relation_dataset* $shm_hitalama_map_widget_float_table_select
										value? <=> relation_dataset*? \
										dictionary <= relation_dataset_options *
										Filter null
							^ select_options_visible* /
								<= Select_options_label* $mol_labeler
									title \Значения (по одному на строке)
									Content <= Select_options* $mol_textarea
										value? <=> select_options*? \
										spellcheck false
							^ relation_display_visible* /
								<= Relation_display_label* $mol_labeler
									title \Отображаемый столбец
									Content <= Relation_display* $shm_hitalama_map_widget_float_table_select
										value? <=> relation_display*? \
										dictionary <= relation_display_options* *
										Filter null
							^ custom_code_visible* /
								<= Col_code_open* $mol_button_minor
									title \Отобразить код
									click? <=> column_editor_open*? null
								<= Col_custom_code_label* $mol_labeler
									title \Код отображения
									Content <= Col_custom_code* $mol_textarea
										value? <=> col_custom_code*? \
										hint \Код должен вернуть содержимое ячейки
										sidebar_showed true
								<= Col_custom_code_help* $mol_view
									sub / <= col_custom_code_help* \
							<= Delete_column* $mol_button_minor
								click? <=> col_delete_ask*? null
								sub /
									<= Delete_column_icon* $mol_icon_trash_can_outline
									\Удалить столбец
							^ col_delete_confirm_visible* /
								<= Delete_column_confirm* $mol_button_major
									title \Подтвердить удаление
									click? <=> col_delete*? null
								<= Delete_column_cancel* $mol_button_minor
									title \Отмена
									click? <=> col_delete_cancel*? null
	All_check $mol_check_group
		checks <= cell_checkboxes /
	checkboxes_showed false
	tools_custom /
		^ deleting_tool_visible / <= Deleting $mol_check_box
			title \Удаление строк
			checked? <=> delete_enabled? false
	settings_content /
		<= Col_widths_head $mol_view
			sub / \Ширина, px
		^ col_width_rows /
			<= Col_width_row* $mol_view
				sub /
					<= Col_width_title* $mol_view
						sub / <= col_settings_title*
					<= Col_width* $mol_number
						Dec null
						Inc null
						value? <=> col_width*? NaN
						hint \auto
	contextmenu_body /
		<= Chart_add $mol_button_minor
			title \Добавить график
			click? <=> chart_add? null
		<= Echarts_add $mol_button_minor
			title \Добавить ECharts
			click? <=> echarts_add? null
		<= Tabulator_add $mol_button_minor
			title \Добавить Tabulator
			click? <=> tabulator_add? null
		^
